const SET_USER = 'scratch-gui/user/SET_USER';
const CLEAR_USER = 'scratch-gui/user/CLEAR_USER';

// 从 localStorage 中读取用户信息作为初始状态
const storedUser = JSON.parse(localStorage.getItem('user'));

// 检查token是否过期的函数
const isTokenExpired = (user) => {
    if (!user || !user.loginTime) return true;
    
    const currentTime = new Date().getTime();
    const timeDiff = currentTime - parseInt(user.loginTime);
    // 如果超过1小时（3600000毫秒），认为token过期
    return timeDiff > 3600000;
};

// 初始化状态前检查token是否过期
let initialStateUser = storedUser;
if (initialStateUser && isTokenExpired(initialStateUser)) {
    // 如果token过期，清除localStorage中的用户信息
    localStorage.removeItem('user');
    localStorage.removeItem('token');
    localStorage.removeItem('username');
    localStorage.removeItem('loginTime');
    initialStateUser = null;
}

const initialState = {
    user: storedUser || null // 如果 localStorage 中有用户信息，则使用它
};
//TODO  这个user需要有获取token的时间，与后台一致，防止一直存在，但还需要登录的问题
const reducer = (state = initialState, action) => {
    switch (action.type) {
        case SET_USER:
            localStorage.setItem('user', JSON.stringify(action.payload)); // 持久化用户信息
            return {
                ...state,
                user: action.payload
            };
        case CLEAR_USER:
            localStorage.removeItem('user'); // 清除持久化的用户信息
            return {
                ...state,
                user: null
            };
        default:
            return state;
    }
};

// Action creators
const setUser = (user) => ({
    type: SET_USER,
    payload: user
});

const clearUser = () => ({
    type: CLEAR_USER
});

export {
    reducer as default,
    initialState as userInitialState,
    setUser,
    clearUser,
};
